

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import "./postChippingPopOver.css";
import { useState } from 'react';
import { type } from '@testing-library/user-event/dist/type';
import { handleNumberFieldFocus } from '../../../common/commonFunction';
function PostChippingPopOver(props) {

  const [values, setValues] = useState(props.values);
  const saveData = (e) => {
    let data = props.data;
    if (props.type === "Un-Restricted") {
      data.postChippingUnrestrictedMoisture = values?.moisture;
      data.postChippingUnrestrictedWeight = values?.weight;
    }
    if (props.type === "Restricted") {
      data.postChippingRestrictedMoisture = values?.moisture;
      data.postChippingRestrictedWeight = values?.weight;
    }
    if (props.type === "Scrap") {
      data.postChippingScrapMoisture = values?.moisture;
      data.postChippingScrapWeight = values?.weight;
    }
    if(props.type === "HeapLocation"){
      data.location =  values?.location;
    }
    props.updatedValues(data);
    props.onClose();
  }

  const handleChange = (e) => {

    setValues({

      ...values,

      [e.target.name]: e.target.value,

    });
  }

  return (
    <div className="pre-chipping-popup-container">
      <div className="bamboo-text">Chipped Bamboo Receipt</div>
      <Container fluid>
        <Row>
          <form onSubmit={(e) => saveData(e)}>
            {props.type != "HeapLocation" &&
              <>
                <Col xs={12} md={9}>
                  <div className="consignment-pick-up-consignment-label" >Moisture</div>
                  <input min= "0" required className='consignment-pick-up-textfields' onChange={(e) => handleChange(e)} name="moisture" value={values.moisture} type="number" onFocus={handleNumberFieldFocus} step=".01"/>
                </Col>
                <Col xs={12} md={9}>
                  <div className="consignment-pick-up-consignment-label" >Weight</div>
                  <input min= "0" required className='consignment-pick-up-textfields' onChange={(e) => handleChange(e)} name="weight" value={values.weight} type="number" onFocus={handleNumberFieldFocus} step=".01"/>
                </Col>
              </>
            }
            {props.type === "HeapLocation" &&
              <>
                <Col xs={12} md={9}>
                  <div className="consignment-pick-up-consignment-label" >Heap Number</div>
                  <input min= "0" required className='consignment-pick-up-textfields' onChange={(e) => handleChange(e)} name="weight" value={props.data.heapNumber} type="text" disabled />
                </Col>
                <Col xs={12} md={9}>
                  <div className="consignment-pick-up-consignment-label" >Heap Location</div>
                  {/* <input required className='consignment-pick-up-textfields' onChange={(e) => handleChange(e)} name="weight" value={values.heapLocation} type="text" /> */}
                  {/* <div className="chipping-order-number-label" >Heap Location</div> */}
                                        <select onChange={(e) => handleChange(e)} name="location" value={values.location} className='consignment-pick-up-textfields-disabled' >
                                                <option>select</option>
                                                <option value={"Bay1"}>{"Bay1"}</option>
                                                <option value={"Bay2"}>{"Bay2"}</option>
                                            </select>
                </Col>
              </>
            }
            {/* <Col xs={12} md={9}>
                              <div className="consignment-pick-up-consignment-label" >Heap Number</div>
                              <input className='consignment-pick-up-textfields' type="text" />
                              </Col> */}
            <Row>
              <Col xs={12} md={6}>
                <div class="pre-chipping-popover-div">
                  <button className='pre-chipping-popover-Btn' type='submit'>Submit</button>
                </div>
              </Col>
            </Row>
          </form>
        </Row>
      </Container>
    </div>
  );
};
export default PostChippingPopOver;
